// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress__T+m-m","bar":"ProgressBar_bar__4vxVY"};